import { useState } from 'react';

/** Runs an async action with a busy flag and an error message. */
export function useAction() {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const run = async (fn: () => Promise<void>, onError: (e: unknown) => string) => {
    setBusy(true);
    setError(null);
    try {
      await fn();
    } catch (e) {
      setError(onError(e));
    } finally {
      setBusy(false);
    }
  };
  return { busy, error, setError, run };
}
